import React from "react";
import { Handshake } from "lucide-react";

export const COLLAB_NOTE = "Collaboration — not FFPLLC property.";

// "COLLAB" badge for shows marked as a collaboration (not Freshy Fresh Productions LLC property).
export function CollabBadge({ size = "sm", solid = false, testId = "collab-badge" }) {
  const cls = size === "lg" ? "text-xs px-2 py-1" : size === "xs" ? "text-[0.55rem] px-1 py-0.5" : "text-[0.6rem] px-1.5 py-0.5";
  return (
    <span
      className={`font-mono-ui uppercase tracking-[0.12em] font-bold inline-flex items-center gap-1 border border-[#5AC8FA] ${solid ? "bg-[#5AC8FA] text-black" : "text-[#5AC8FA]"} ${cls}`}
      title={COLLAB_NOTE}
      data-testid={testId}
    >
      <Handshake size={size === "lg" ? 13 : 10} /> COLLAB
    </span>
  );
}

// Checkbox used by the show editors (Dashboard → Shows and Schedule quick-add).
export function CollabCheckbox({ checked, onChange, testId = "show-collab" }) {
  return (
    <label className="flex items-start gap-3 cursor-pointer pt-2 border-t border-[var(--ff-border)]">
      <input type="checkbox" checked={!!checked} onChange={(e) => onChange(e.target.checked)} className="w-4 h-4 mt-0.5 accent-[#5AC8FA]" data-testid={testId} />
      <span>
        <span className="font-mono-ui text-xs uppercase tracking-[0.15em] inline-flex items-center gap-1.5"><Handshake size={12} className="text-[#5AC8FA]" /> Collaboration — not FFPLLC property</span>
        <span className="block text-[0.65rem] text-[var(--ff-text-dim)] font-mono-ui mt-0.5">Shows a COLLAB badge and keeps the show off the leaderboard.</span>
      </span>
    </label>
  );
}
